import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { Grid, Box, Typography, Button } from '@material-ui/core';
import { getBaseUrl } from 'helper/utils';
import useStyles from './ftux.style';
import CustomDatasetJoyride from './Joyride';
import { colors } from 'theme/color-palette';
import {
	CDTourFlag,
	CDS_LEARN_MORE,
	LEARN_MORE,
	NEW_EXCLAMATION,
	CUSTOM_DATASET,
	CUSTOM_DATASET_ILLUSTRATION,
	CUSTOM_SHOWME_HOW
} from 'constants/constant';
import { trackEventInfo } from 'helper/analytics';
import { PAGE_ID, EVENTS, ACTION_ON } from 'constants/tracker';
import { setCustomDatasetTour } from 'components/UserTour/Tour.action';

const FtUXInitBox = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const [showThis, setShowThis] = useState(true);

	const onClose = () => {
		setShowThis(false);
		localStorage.setItem(CDTourFlag, true);
		dispatch(setCustomDatasetTour({ CDTourRun: false, CDTourStepIndex: 0 }));
	};

	const onShowMeClick = () => {
		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn: ACTION_ON.CUSTOM_DATASET_TOUR_SHOW_ME_HOW,
			location: PAGE_ID.TEMPLATES
		});
		dispatch(setCustomDatasetTour({ CDTourRun: true }));
	};

	const onLearnMoreClick = (e) => {
		e.stopPropagation();
		window.open(`${getBaseUrl()}${CDS_LEARN_MORE}`, '_blank', 'noreferrer');
		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn: ACTION_ON.CUSTOM_DATASET_LEARN_MORE,
			location: PAGE_ID.TEMPLATES
		});
	};

	if (!showThis) {
		return null;
	}

	return (
		<Grid item xs={12} sm={12} md={6} lg={4} className={classes.card}>
			{/* Show me how Box */}
			<Box className={classes.initBox}>
				<Box className={classes.initHeading}>
					<Typography className={classes.initHeadingText} style={{ color: colors.PURPLE }}>
						{NEW_EXCLAMATION}&nbsp;
					</Typography>
					<Typography className={classes.initHeadingText}>{CUSTOM_DATASET}</Typography>
					<CloseIcon className={classes.closeIcon} onClick={onClose} />
				</Box>
				<Typography className={classes.initContent}>{CUSTOM_DATASET_ILLUSTRATION}</Typography>
				<Box className={classes.initFooter}>
					<Button disableRipple className={classes.initShowBtn} onClick={onShowMeClick}>
						{CUSTOM_SHOWME_HOW}
					</Button>
					<Button
						disableRipple
						disableTouchRipple
						onClick={onLearnMoreClick}
						className={classes.learnMoreBtn}>
						{LEARN_MORE}
						<OpenInNewIcon className={classes.openInNewIcon} fontSize="small" />
					</Button>
				</Box>
			</Box>
		</Grid>
	);
};

export { CustomDatasetJoyride };

export default FtUXInitBox;
